(() => {
  if (window.saMaskFeaturesInitialized) return;
  window.saMaskFeaturesInitialized = true;

  // Show the elastic or straw rope row to match the selected strap option. Mask pages name the option on the
  // block; bundle pages name it on each strap row (each mask has its own option, snippets/sa-bundle-components.liquid).
  const syncStrap = (features) => {
    const scope = features.closest('product-info') || features.closest('.shopify-section');
    const picker = scope?.querySelector('variant-selects');
    if (!picker) return;
    features.querySelectorAll('[data-strap-feature]').forEach((row) => {
      const optionName = row.dataset.strapOption || features.dataset.strapOption;
      if (!optionName) return;
      const group = Array.from(picker.querySelectorAll('[data-option-name]')).find((node) =>
        node.matches('fieldset, .product-form__input--dropdown') && node.dataset.optionName === optionName
      );
      const selection = group?.querySelector('input:checked, select');
      if (!selection) return;
      const rope = selection.value.toLowerCase().includes('straw rope');
      row.hidden = (row.dataset.strapFeature === 'rope') !== rope;
    });
  };
  const syncAll = () => document.querySelectorAll('[data-mask-features]').forEach(syncStrap);
  syncAll();
  document.addEventListener('change', (event) => {
    if (event.target.closest?.('variant-selects')) syncAll();
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, syncAll);
  }
})();
